import { gql } from "@apollo/client";

export const GET_PURCHASERS_LOOKUP = gql`
  query PurchasersLookup {
    purchasersLookup {
      count
      items {
        purchaserId
        purchaserKey
        purchaserName
        purchaserIsActive
        configTemplate {
          configTemplateId
          appPurchaserId
          metadata
          searchKeywords
          intelligenceFilter
          deductionTypeInvoicePatternForDiscount
          additionalFieldMapping
          discountTermAgreementDaysTolerance
          isActive
        }
      }
    }
  }
`;
